// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { getOpenBids, OpenBidsApiParameter, OpenBidsModel } from "@steiner/App/Services/OpenBidsService";

type HandlerType = ApiHandler<OpenBidsApiParameter & HasOnSuccess, OpenBidsModel>;

export const defaultParameters = {
    customerSequence: "-1",
    orderNumber: "",
    releaseNumber: "",
    poNumber: "",
    page: 1,
    pageSize: 8,
    fromDate: "",
    toDate: "",
};

export const DispatchBeginLoadOpenBids: HandlerType = props => {
    props.dispatch({
        type: "xOpenBids/BeginLoadingOpenBids",
        isLoading: true,
    } as any);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getOpenBids(props.apiParameter);
    } catch (error) {
        props.dispatch({
            type: "xOpenBids/FailedLoadingOpenBids",
        } as any);
        return false;
    }
};

export const DispatchCompleteLoadOpenBids: HandlerType = props => {
    props.dispatch({
        type: "xOpenBids/CompleteLoadingOpenBids",
        value: props.apiResult,
    } as any);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginLoadOpenBids,
    PopulateApiParameters,
    RequestDataFromApi,
    DispatchCompleteLoadOpenBids,
    ExecuteOnSuccessCallback,
];

const loadOpenBids = createHandlerChainRunnerOptionalParameter(chain, defaultParameters, "loadOpenBids");

export default loadOpenBids;
